import { useParams } from "react-router-dom";
import BroadcasterViewDual from "./../components/BroadcasterViewDual.react";
import { BroadcastErrorBoundary } from "./../components/ErrorBoundaries.react";


export default function BroadcasterViewDualRoute(): React$Element<any> {
  let params = useParams();
  // 송출 화면이 죽으면 방송에 자막이 사라진다 — 빈 화면으로 두고 자동 새로고침 (#203)
  return (
    <BroadcastErrorBoundary>
      <BroadcasterViewDual sessionId={params.sessionId} />
    </BroadcastErrorBoundary>
  );
}
